import { Component } from 'react';

import { FatalAttraction as FA } from '@vpr/tracking';

import { translate } from '@vimeo/i18n-runtime';

import PlayLogo from './play.svg';
import styles from './UpNext.module.scss';

class UpNext extends Component {
  constructor(props) {
    super(props);

    this.state = { isShowing: true };
  }

  componentDidMount = () => {
    // Add a transparent overlay above the player:
    const playerEl = document.querySelector('.vp-video-wrapper');
    if (playerEl) {
      playerEl.classList.add('dimmed');
    }

    if (this.state.isShowing) {
      FA.trackImpression({
        container: 'embedded_playlist',
        component: 'up_next',
        keyword: 'up_next_shown',
      });
    }
  };

  componentWillUnmount = () => {
    // Remove the transparent overlay above the player:
    const playerEl = document.querySelector('.vp-video-wrapper');
    if (playerEl) {
      playerEl.classList.remove('dimmed');
    }
    // Ensures Playlist continues showing/hiding based on controls:
    this.props.onMouseLeave();
  };

  playNextClip = () => {
    this.setState(() => ({
      isShowing: false,
    }));

    FA.trackClick({
      container: 'embedded_playlist',
      component: 'up_next',
      keyword: 'up_next_pressed',
    });

    const { clip, clips, switchClip, loop } = this.props;

    const nextIndex = clips.findIndex((e) => e.id === clip.id);
    // If next clip is the beginning of playlist, don't autoplay:
    const autoplay = nextIndex !== 0 || loop;
    switchClip(clip, autoplay);
  };

  render() {
    const { clip } = this.props;

    return (
      <div className={`${styles.upNext} ${this.state.isShowing ? '' : styles.hide}`}>
        <span className={styles.upNextHeader}>{translate('Up Next')}</span>
        <div className={styles.upNextThumbnailContainer} onClick={this.playNextClip}>
          <div
            className={styles.upNextThumbnailImage}
            style={{ backgroundImage: `url(${clip.thumbnail})` }}
          />
          <span className={styles.upNextClipDuration}>{clip.duration}</span>
          <div className={styles.upNextProgressContainer}>
            <div className={styles.upNextProgressBar}>
              <div className={styles.upNextPlayIcon} alt="Play">
                <PlayLogo />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.upNextDescription}>
          <p className={styles.upNextClipTitle} title={clip.title}>
            {clip.title}
          </p>
          <p className={styles.upNextClipOwner} title={clip.owner}>
            {clip.owner}
          </p>
        </div>
      </div>
    );
  }
}

export default UpNext;
